export enum PromotionEndpoints {
  ROOT = '/promotion',
}

export const staticPromotionEndpoints = {
  CREATE_PROMOTION: PromotionEndpoints.ROOT,
};

export const getPromotionEndpoints = ({ id, channelId }: { id?: string; channelId?: string | number }) => ({
  UPDATE_PROMOTION: `${PromotionEndpoints.ROOT}/${id}`,
  GET_PROMOTIONS_LIST: `${PromotionEndpoints.ROOT}/${channelId}`,
});

export enum PromotionStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum PromotionTemplate {
  DARK = 0,
  DIMENSIONAL = 1,
  PURPLE = 2,
  OUTSIDE_THE_BOX = 3,
  GIFT = 4,
}

export interface IPromotion {
  id: string;
  channelId: number;
  name: string;
  status: PromotionStatus;
  description: string;
  rate: number;
  minOrderAmount?: null | number;
  templateNumber: PromotionTemplate;
  dateFrom?: null | string;
  dateTo?: null | string;
  code: string;
  createdAt: string;
  updatedAt: string;
}

// ============== DTOs ==============
export interface IGetPromotionsListDTO {
  channelId: number;
}

type TPromotionCreatableFields =
  | 'code'
  | 'dateFrom'
  | 'dateTo'
  | 'description'
  | 'minOrderAmount'
  | 'name'
  | 'rate'
  | 'channelId'
  | 'templateNumber';

export interface ICreatePromotionDTO extends Pick<IPromotion, TPromotionCreatableFields> {}

type TPromotionUpdatableFields =
  | 'code'
  | 'dateFrom'
  | 'dateTo'
  | 'description'
  | 'minOrderAmount'
  | 'name'
  | 'rate'
  | 'status'
  | 'templateNumber';

export interface IUpdatePromotionDTO extends Partial<Pick<IPromotion, TPromotionUpdatableFields>> {
  id: string;
}

// ============== Response ==============
export type TGetPromotionsListResponse = {
  promotions: IPromotion[];
};

export type TCreatePromotionResponse = IPromotion;

export type TUpdatePromotionResponse = IPromotion;
